import { render, staticRenderFns } from "./GrpInsAssignmentGrid.vue?vue&type=template&id=3a89a633"
import script from "./GrpInsAssignmentGrid.vue?vue&type=script&lang=js"
export * from "./GrpInsAssignmentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports